import request from "root/js/request";

export const getItemStatisticsInSizeCrossMP = async ({
  cabinet_id,
  cabinet_id__in,
  marketplace,
  by,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/dynamic/statistics/in_size/",
    method: "get",
    params: {
      cabinet_id,
      cabinet_id__in,
      marketplace,
      ...rest,
    },
  });
  return response.data;
};
